import { useState } from 'react'
import { Choice } from '@/components/Choice'
import { FormError } from '@/components/FormError'
import { Button } from '@/components/ui/button'
import { useConnectionSettings, useSaveConnectionSettings, useTurnOffLinks } from '@/lib/connections'

// Your own choices about connecting, on My profile: a Private or Public profile, whether anyone may see what you've
// shared with Everyone (only while Public), whether a request is emailed to you, and turning off every connect link
// you've made.
export function ConnectionChoices() {
  const settings = useConnectionSettings()
  const save = useSaveConnectionSettings()
  const off = useTurnOffLinks()
  const [linksOff, setLinksOff] = useState(false)
  if (!settings.data) return <FormError error={settings.error} />
  return (
    <section aria-labelledby="connecting" className="flex flex-col gap-6 border-t pt-8">
      <div className="flex flex-col gap-1">
        <h2 id="connecting" className="text-title">
          Connecting
        </h2>
        <p className="text-sub text-muted-foreground">Who can find you, and how you hear about requests.</p>
      </div>
      <Choice
        legend="My profile"
        hint={
          settings.data.public
            ? 'Anyone on gatheredfrom can find you and ask to connect. You still say yes.'
            : 'Only people you already know can find you. Anyone else needs your link, your QR code or your email.'
        }
        value={settings.data.public ? 'public' : 'private'}
        options={[
          ['private', 'Private'],
          ['public', 'Public'],
        ]}
        onChange={(v) => save.mutate({ public: v === 'public' })}
      />
      {settings.data.public && (
        <Choice
          legend="Anyone can see my stuff"
          hint={
            settings.data.open
              ? 'What you’ve shared with Everyone opens for anyone on gatheredfrom. Nothing else does.'
              : 'What you’ve shared with Everyone stays with the people you know.'
          }
          value={settings.data.open ? 'on' : 'off'}
          options={[
            ['off', 'No'],
            ['on', 'Yes'],
          ]}
          onChange={(v) => save.mutate({ open: v === 'on' })}
        />
      )}
      <Choice
        legend="Email me when someone asks to connect"
        value={settings.data.email ? 'on' : 'off'}
        options={[
          ['on', 'Yes'],
          ['off', 'No'],
        ]}
        onChange={(v) => save.mutate({ email: v === 'on' })}
      />
      <FormError error={save.error ?? off.error} />
      <div className="flex flex-col gap-2">
        <Button
          variant="outline"
          className="self-start"
          disabled={off.isPending}
          onClick={() => off.mutate(undefined, { onSuccess: () => setLinksOff(true) })}
        >
          Turn off my connect links
        </Button>
        <p role="status" className="text-sub text-muted-foreground">
          {linksOff
            ? 'Done. Links you’ve shared no longer work. You can make a new one on People.'
            : 'Every link and QR code you’ve shared stops working. Requests already made stay for you to answer.'}
        </p>
      </div>
    </section>
  )
}
